// Auto-reply templates per visa type. Uses placeholders that CRM fills.
export const REPLY_TEMPLATES = {
  Work: {
    subject: "Next steps for your {country} work visa application",
    body: `Hi {firstName},

Thank you for reaching out to NextShore Immigration about a work visa for {country}.

Based on your {timeline} timeline, here is what we'll need from you to get started:
  • Passport bio page (color scan)
  • Latest CV / resume
  • Highest education certificate
  • Employer offer letter (if you already have one)

Please reply to this email with the documents above and we'll schedule a 20-minute call to map out your route.

Best regards,
NextShore Immigration Team`,
  },
  Study: {
    subject: "Your {country} study visa — documents checklist",
    body: `Hi {firstName},

Thank you for your interest in a {country} student visa. To move forward, please share:
  • Passport bio page
  • Academic transcripts and highest degree
  • English proficiency score (IELTS / TOEFL / Duolingo)
  • Statement of purpose (draft is fine)
  • Proof of funds (bank statement or sponsor letter)

Once we have these, we'll shortlist universities that match your profile and budget.

Best regards,
NextShore Immigration Team`,
  },
  Tourist: {
    subject: "Your {country} tourist visa — getting started",
    body: `Hi {firstName},

Thanks for choosing NextShore for your {country} tourist visa. To prepare your file we'll need:
  • Passport (6+ months validity)
  • Recent photograph (visa-compliant)
  • Travel itinerary and hotel bookings
  • Last 3 months bank statements
  • Employment / student letter

Reply with these and we'll take care of the rest.

Best regards,
NextShore Immigration Team`,
  },
  "Permanent Residency": {
    subject: "Your {country} PR pathway — initial assessment",
    body: `Hi {firstName},

Congratulations on taking the first step toward permanent residency in {country}.

To assess your eligibility (points, category, and route) we'll need:
  • Full CV with month-year employment dates
  • Highest education certificate
  • English test score (if taken)
  • Passport bio page
  • Marital status and dependents (if any)

We'll come back within 48 hours with a personalized route and expected timeline.

Best regards,
NextShore Immigration Team`,
  },
  Business: {
    subject: "Your {country} business / investor visa — next steps",
    body: `Hi {firstName},

Thank you for considering NextShore for your {country} business route.

To structure the right route (Golden Visa, Innovator, Investor, etc.) please share:
  • Business plan or executive summary
  • Last 2 years personal / company bank statements
  • Passport bio page
  • Source of funds documentation

We'll book a confidential 30-minute strategy call once these arrive.

Best regards,
NextShore Immigration Team`,
  },
};

export function fillTemplate(tpl, lead) {
  const firstName = (lead.name || "").split(" ")[0] || "there";
  const map = {
    "{firstName}": firstName,
    "{country}": lead.target_country || "",
    "{visaType}": lead.visa_type || "",
    "{timeline}": lead.timeline || "",
  };
  const replace = (s) => Object.entries(map).reduce((acc, [k, v]) => acc.split(k).join(v), s);
  return { subject: replace(tpl.subject), body: replace(tpl.body) };
}
